<template>
    <vx-selectable v-model="model"
        placeholder="Search Group"
        :reduce="props.reduce"
        :clearable="props.clearable"
        :loading="loading"
        :options="response || []"
        @search="search"
        data-test="group-selectable">
        <template v-slot:option="option">
            <slot name="option" v-bind="option"></slot>
        </template>
    </vx-selectable>
</template>

<script setup>
import { VxSelectable } from '@voxie/frontend-components';
import { computed, onUnmounted } from 'vue';
import { groupsClient } from '~/services';
import { useSearchRequest } from '~/composables/useSearchRequest';
import { GROUP_STATUSES_SENDING } from '~/constants/groupStatuses';

const model = defineModel();

const props = defineProps({
    orgUnitId: {
        type: Number,
    },
    reduce: {
        type: Function,
        default: (option) => option.value,
    },
    clearable: {
        type: Boolean,
        default: true,
    },
    teamId: {
        type: Number,
        default: undefined,
    },
    statuses: {
        type: Array,
        default: () => GROUP_STATUSES_SENDING,
    },
});

const teamId = props.teamId ?? Spark.state.currentTeam.id;

const {
    loading,
    response,
    createSearch,
    cancelSearch,
    cancelKey,
} = useSearchRequest(groupsClient);

const context = computed(() => ({ teamId, orgUnitId: props.orgUnitId }));

const search = createSearch(async (query) => {
    const { data } = await groupsClient.getGroups(context.value, {
        query: query,
        setup_required: 0,
        status: props.statuses,
    }, {
        cancelKey: cancelKey,
    });

    return data.data.map((group) => ({
        ...group,
        value: group.group_id,
        label: `${group.name} - ${group.group_id}`.trim()
    }));
});

// Initialize with empty search
search();

// Clean up on component unmount
onUnmounted(() => {
    cancelSearch(context.value);
});
</script>
